import { LoadCategoriesList, LoadCountriesList } from './listings.actions';

export const ListingsLoadingActions = [LoadCategoriesList, LoadCountriesList];
